import { Component, OnInit, Output, EventEmitter, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { ContenusService } from 'src/app/services/contenus.service';
import { MessageService } from 'primeng/api';
import { SocketModule } from 'src/app/socket/socket.module';
import {Socket} from 'ngx-socket-io'

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.css'],
  providers : [MessageService]
})
export class DescriptionComponent implements OnInit {

  @ViewChildren('description') textAreas: QueryList<ElementRef>;

  disabledTextArea: boolean;
  btnModifierLabel : string;
  duplicateName: string;
  validName: string;
  cqName: string;
  douteName: string;
  motifs: Object[] = [];
  motifsCq: Object[] = [];
  errors: SelectItem[] = [];
  ContenusAnterieurs : Object[] = [];
  selectedErrors : Object[] = [];
  
  
  @Input('attente-doute') attenteDoute : boolean = false;
  @Input('id-moderation') idModeration : string;
  @Input('numero-contenu') numContenu : string;
  @Input('content') content : string; 
  @Input('cq') cq : boolean = false;
  @Input('read-only') readonly: boolean = false;
  @Input('valide') valid: boolean = false;
  @Input('valide-cq') validationCQ: boolean = null;
  @Input('duplicate') duplicate: boolean = false;
  @Input('erreurs') inputErreurs : Object[] = [];
  @Input("erreurs-cq") inputErreursCq : Object[] = [];
  @Input("doute") isDoute : boolean = false;
  @Input('is-retour') isRetour : boolean = false;
  @Input('type-contenu') typeContenu : string = "description"; //=> type du contenu (titre BP, phrase d'accroche, etc...)

  @Output() validChangedEvent = new EventEmitter<boolean>();
  @Output() validCqChangedEvent = new EventEmitter<boolean>();
  @Output() descriptionChangedEvent = new EventEmitter<string>();
  @Output() erreursChangedEvent = new EventEmitter<Object[]>();
  @Output() erreursCqChangedEvent = new EventEmitter<Object[]>();
  @Output() douteEvent = new EventEmitter<Object>();


  contenuFormated : string;

  constructor(private contenuService : ContenusService, private msgService : MessageService, private socket : Socket) { }

  ngOnInit(): void {
    
    let typeTraitement = (this.cq === true) ? 1 : 0;
    this.contenuService.recupererListeMotifs(4, typeTraitement).subscribe(results => { //=> 4 est l'id du contenu description
      if(results["status"] !== "success"){
        console.log("Une erreur dans la requête:" + results["cause"]);
      }else {
        let input = results["data"]; 
        this.initErrors(input);
      }

      if(this.inputErreurs !== null && this.inputErreurs !== undefined) this.motifs = this.inputErreurs;
      if(this.inputErreursCq !== null && this.inputErreursCq !== undefined) this.motifsCq = this.inputErreursCq;

      this.selectedErrors = this.motifs;
      // Validation nombre caractere minimum autorisée automatique
      if(this.getNbOfCharachter() < 100 && this.valid ===null) {
         const typesAvecControle = ['titreBonPlan', 'phraseAccroche', 'detail'];
        if(!typesAvecControle.includes(this.typeContenu)){
          this.setTexteIncomplet();
        } 
      }
      // validation nombre de caractere maximum autorisée automatique
      if(this.getNbOfCharachter() > 800 && this.valid ===null) {
        this.setTexteTropLong();
      }
      /* if(this.getNbOfCharachter() > 800) {
        this.motifs = [
          {
            id_motif : "16",
            designation_motif : "Duplicate content",
            code_rejet : "MD001"
          }
        ];
      } */
    });

    let optionsForEtatsAnterieurs = {
      idModeration : this.idModeration,
      numContenu : this.numContenu
    }

    this.contenuService.recupererEtatsAnterieurs(optionsForEtatsAnterieurs).subscribe(results => {
      if(results["status"] !== "success"){
        console.log("Une erreur dans la requête:" + results["cause"]);
      }else {
        let listeContenus = results["data"];

        listeContenus.forEach(current => {
          this.ContenusAnterieurs.push(current);
        });
      }
    });


    this.disabledTextArea = false;
    this.btnModifierLabel = "Modifier le contenu";
    this.duplicateName = this.generateRandomString();
    this.validName = this.generateRandomString();
    this.cqName = this.generateRandomString();
    this.douteName = this.generateRandomString();
    //this.contenuFormated =  this.changeNewLineInvert(this.content);
    this.contenuFormated = this.content;
  }




  textToHtml(text : string) {
    //return text.replace("\/n", "<br>");
    return text.replace("\\n", "<br>");
  }

  /**
   * Formatte le tableau d'erreur
   */
  initErrors(input) {
    input.forEach(current => {
      let motif = {
        label : current["designation_motif"],
        value : current
      };
      this.errors.push(motif);
    });

  }




  /**
   * Utilisé pour créer des identifiants uniques aux radios
   */
  generateRandomString (length=6){
    return Math.random().toString(20).substr(2, length)
  }


  getNbOfCharachter() : number {
    return (this.contenuFormated) ? this.contenuFormated.length : 0;
  }


  /**
   * 
   * @param contenu 
   * Emet la valeur du contenu au parent à chaque changement
   */
  descriptionChanged(contenu: string) {
    this.descriptionChangedEvent.emit(contenu);
  }


  /**
   * Change \n en /n (bizarrement .replace ne prend que la première occurence)
   * @param contenu 
   */
  changeNewLine(contenu : string) {
    contenu = contenu.replace('\n', '/n');
    //console.log(contenu);
    //console.log(contenu.includes('\n'));
    if(contenu.includes('\n')) {
      contenu = this.changeNewLine(contenu);
    } 
    
    return contenu;
    
  }


  /**
   * Change /n en \n 
   * @param contenu 
   */
  changeNewLineInvert(contenu : string) {
    contenu = contenu.replace('/n', '\n');
    //console.log(contenu);
    //console.log(contenu.includes('/n'));
    if(contenu.includes('/n')) {
      contenu = this.changeNewLineInvert(contenu);
    } 
    console.log(contenu)
    return contenu;
    
  }

  /**
   * @param valid
   * Emet la valeur de OK ou KO du contenu à chaque changement
   */
  validChanged(valid: boolean) {
    if(valid) {  
      this.motifs = [];
      this.setErrors(this.motifs);
    }
    this.validChangedEvent.emit(valid);
  }
  
  validCqChanged(valid : boolean) {
    if(valid) {
      this.motifsCq = [];
      this.setCqErrors(this.motifsCq);
    }
    this.validCqChangedEvent.emit(valid);
  }

  /**
   * 
   * @param duplicated 
   * Vérifie si un contenu est dupliqué ou non et change la valeur de valid en fonction
   */
  duplicateChanged(duplicated: boolean) {
    if(duplicated === true) {
      this.motifs = [
        {
          id_motif : 16,
          designation_motif : "Duplicate content",
          code_rejet : "MD001"
        }
      ];
      this.valid = false;
      this.validChanged(false);
  
    }else {
      this.motifs = [];
    }

    this.erreursChangedEvent.emit(this.motifs);
  }


  /**
   * Ajoute automatiquement le motif texte incomplet
   */
  setTexteIncomplet() {
    this.motifs = [
      {
        id_motif : 17,
        designation_motif : "Texte incomplet, trop court",
        code_rejet : "MD002"
      }
    ];
    this.valid = false;
    this.selectedErrors = this.motifs;
    this.validChanged(false);
    this.erreursChangedEvent.emit(this.motifs);
  }

  /**
   * Ajoute automatiquement le motif texte incomplet
   */
  setTexteTropLong() {
    this.motifs = [
      {
        id_motif : 40,
        designation_motif : "Texte trop long",
        code_rejet : "MD013"
      }
    ];
    this.valid = false;
    this.selectedErrors = this.motifs;
    this.validChanged(false);
    this.erreursChangedEvent.emit(this.motifs);
  }

  /**
   * Rend le contenu de la description éditable ou non
   */
  setEditable() {
    this.disabledTextArea = !this.disabledTextArea;

    if(this.disabledTextArea === true) {
      this.btnModifierLabel = "Modifier le contenu";
    } else {
      this.btnModifierLabel = "Fin des modifications";
    }
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs à chaque changement
   */
  setErrors(errors: Object[]) {
    this.motifs = errors;
    this.erreursChangedEvent.emit(errors);
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs de cq à chaque changement
   */
  setCqErrors(errors: Object[]) {
    this.motifsCq = errors;
    this.erreursCqChangedEvent.emit(errors);
  }


  /**
   * copie du texte de la description dans le clipboard
   * @param detail 
   */
  descriptifCopied(detail: string) {
    let slicedDetail = detail.slice(0,25) + "...";

    this.msgService.add({
      severity:'info',
      summary:'Description mise dans le clipboard',
      detail: slicedDetail
    })
  }


  /**
   * Recherche google de la description
   * @param contenu 
   */
  redirectToGoogle(contenu : string) {
    console.log(escape(contenu));
    contenu = "https://www.google.com/search?q=" + escape(contenu);
    contenu = contenu.replace(/%u0153/g, 'oe');
    contenu = contenu.replace(/%u2019/g, '\'');
    //var url = encodeURI(contenu);
    window.open(contenu, "_blank");
  }


  /**
   * Fonction qui envoie les données du contenu en cas de doute
   */
  doute(doute: boolean) {
    
    if(doute) {
      this.valid = null;
      this.validChanged(null);
      this.duplicate = false;
      this.setErrors([]);
    }

    let options = {
      doute : doute,
      numContenu : this.numContenu,
      type  : this.typeContenu
    };

    this.douteEvent.emit(options);
  }


  /**
   * bloquer la modification du texte
   */
  disableModeration() { //valeur de disabled 
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.isDoute || this.cq) {
      return true;
    }

    return false;
  }

  /**
   * 
   * @returns boolean
   */
  disableDoute() { 
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.cq) {
      return true;
    }
  }

  /**
   * ouvre antidote
   * @tâche appel socket vers le serveur socket 
   * @param contenu 
   */
  openAntidote(contenu:string) {
    this.textAreas.toArray()[0].nativeElement.focus();
    this.socket.emit('antidote', 'test');
  }
}
